<template>
    <div class="container">
        <div class="back" @click="goBack"><i class="el-icon-back"></i> 返回</div>
        <el-form ref="form" :model="form" :rules="rules" label-width="140px" class="package-form">
            <BaseInfoFields :form="form"></BaseInfoFields>

            <el-form-item label="可售设备型号" required>
                <SearchInnerModel v-model="form.product_models" :multiple="true" placeholder="选择设备型号，可多选" style="width: 420px"></SearchInnerModel>
                <div class="help-text">套餐卖给哪些设备由型号决定，一个套餐可绑多个型号（如 AF-C100、AF-C200、WF-100）。</div>
            </el-form-item>

            <el-form-item label="上架区域" required>
                <el-select v-model="form.regions" multiple filterable allow-create default-first-option
                    placeholder="请选择或输入区域码" style="width: 420px">
                    <el-option v-for="region in regionOptions" :key="region" :label="region" :value="region"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="价格" required>
                <PriceEditor v-model="form.prices"></PriceEditor>
            </el-form-item>

            <el-form-item label="权益特性">
                <FeatureEditor v-model="form.ext_features" @remove="(item, index) => form.ext_features.splice(index, 1)"></FeatureEditor>
            </el-form-item>

            <el-form-item>
                <div class="help-text">每个套餐都是付费订阅套餐，必须配价格并在 Chargebee 建好商品。创建后为「测试」状态（型号已随创建绑定），经测试账号验收后即可上架。</div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" :loading="submitting" @click="submit">创建套餐</el-button>
                <el-button @click="goBack">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import api from '../../../axios/pack'
import SearchInnerModel from '../../../components/device/SearchInnerModel.vue'
import BaseInfoFields from './BaseInfoFields.vue'
import PriceEditor from './PriceEditor.vue'
import FeatureEditor from './FeatureEditor.vue'
import {
    REGION_OPTIONS, baseRules, basePayload, validatePriceList, validateFeatureList, formatPrices, formatFeatures
} from './constants'

export default {
    name: 'PetPackageCreate',
    components: { SearchInnerModel, BaseInfoFields, PriceEditor, FeatureEditor },
    data() {
        return {
            regionOptions: REGION_OPTIONS,
            submitting: false,
            form: {
                name: '',
                service_time: 1,
                service_time_unit: 'MONTH',
                cycles: 0,
                file_time: 0,
                trial_days: 0,
                level: 0,
                tag: '',
                sort_order: 0,
                explain: '',
                regions: [],
                product_models: [],
                prices: [{ currency: 'USD', price: null, sale_price: null }],
                ext_features: []
            },
            rules: baseRules()
        }
    },
    methods: {
        validateExtra() {
            if (!this.form.product_models.length) return '请选择可售设备型号'
            if (!this.form.regions.length) return '请选择上架区域'
            const priceError = validatePriceList(this.form.prices)
            if (priceError) return priceError
            return validateFeatureList(this.form.ext_features)
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return
                const message = this.validateExtra()
                if (message) return this.$message.error(message)
                this.submitting = true
                const payload = {
                    ...basePayload(this.form),
                    regions: this.form.regions.map(item => item.toLowerCase()),
                    product_models: this.form.product_models,
                    prices: formatPrices(this.form.prices),
                    ext_features: formatFeatures(this.form.ext_features)
                }
                api.PetPackageCreate(payload).then(res => {
                    if (res.data.code == 200) {
                        // 部分币种可能在 Chargebee 建价失败，跳详情页核对实际落库的数据
                        this.$message.success('套餐创建成功，请核对实际落库的币种价格')
                        this.$router.push('/iot/petpack/detail/' + res.data.data.code)
                        return
                    }
                    this.$message.error('创建失败：' + res.data.msg)
                }).finally(() => {
                    this.submitting = false
                })
            })
        },
        goBack() {
            this.$router.push('/iot/petpack')
        }
    }
}
</script>

<style scoped>
.back { margin-bottom: 16px; width: 60px; cursor: pointer; font-size: 14px; }
.package-form { max-width: 960px; }
.help-text { color: #909399; font-size: 12px; }
</style>
